export default {
  PASSWORD_TYPE: {
    text: 'text',
    password: 'password',
  },
  PASSWORD_ICON: {
    show: require("@/assets/icons/show_eye.svg"),
    hide: require("@/assets/icons/hide_eye.svg"),
  }
};